module.exports = __webpack_public_path__ + "img/fox.17d9f970.png";